import React from 'react'; // Helper to get subdirectory from window variable (set in UIRouter.tsx).

var getSubdirectory = function getSubdirectory() {
  if (typeof window !== 'undefined' && window.__TB_SUBDIRECTORY__) {
    var subdirectory = window.__TB_SUBDIRECTORY__; // Return without trailing slash.

    return subdirectory && subdirectory.endsWith('/') ? subdirectory.slice(0, -1) : subdirectory || '';
  }

  return '';
};

export var Svg = function Svg(_ref) {
  var path = _ref.path,
      label = _ref.label,
      root = _ref.root;
  var subdirectory = getSubdirectory();
  var defaultRoot = '/images/sprites.svg'; // If root is provided and absolute URL, use it as-is; otherwise prepend subdirectory.

  var rootPath;

  if (root) {
    if (root.startsWith('http://') || root.startsWith('https://')) {
      rootPath = root;
    } else {
      rootPath = "".concat(subdirectory).concat(root.startsWith('/') ? root : "/".concat(root));
    }
  } else {
    rootPath = "".concat(subdirectory).concat(defaultRoot);
  }

  return React.createElement("svg", {
    "aria-label": label
  }, React.createElement("use", {
    href: "".concat(rootPath, "#").concat(path)
  }));
};